import baseRequest from "./requests/base-request";
import bizRequest from "./requests/biz-request";

export default Object.assign({}, bizRequest, baseRequest);
